import Users from "@Front/Api/LeCoffreApi/Notary/Users/Users";
import { formatOptionalContactEmailForDisplay } from "@Front/Utils/notaryContactEmailDisplayHelpers";
import { LoggerService } from "@Front/Services/LoggerService/LoggerService";
import User from "le-coffre-resources/dist/Notary";
import { useEffect, type Dispatch, type SetStateAction } from "react";
import { useRolePermissions } from "@Front/Stores/RolePermissionsStore";

/**
 * Loads the current user from the API when the session has users:read permission.
 */
export function useLoadUserWhenPermitted(setUser: Dispatch<SetStateAction<User | null>>): void {
	const { permissionContext, can } = useRolePermissions();

	useEffect(() => {
		const userId = permissionContext?.userId;
		if (!userId) {
			return;
		}

		if (!can("users", "read")) {
			return;
		}

		let isMounted = true;

		void Users.getInstance()
			.getByUid(userId, {
				q: {
					contact: true,
				},
			})
			.then((fetchedUser) => {
				if (!isMounted) return;
				const userEmail = formatOptionalContactEmailForDisplay(fetchedUser?.contact?.email);
				LoggerService.info("👤 [useUser] Utilisateur connecté", {
					userEmail,
					userUid: userId,
				});
				setUser(fetchedUser);
			})
			.catch((error: unknown): void => {
				LoggerService.warn("ℹ️ [useUser] Erreur chargement utilisateur (ignorée)", { error, userId });
			});

		return (): void => {
			isMounted = false;
		};
	}, [permissionContext?.userId, permissionContext?.globalRole, can, setUser]);
}
